import { Device } from '@interfaces';

export class DeviceDetection {
    public static detectedDevice: Device = 'desktop';
    public static isDetected: boolean = false;
    public static currentUserAgent: string = '';

    /**
     * Regex from here
     * https://support.cloudflare.com/hc/en-us/articles/229373388-Cache-Content-by-Device-Type-Mobile-Tablet-Desktop-
     */
    private static mobileDetection(userAgent: string): boolean {
        const regex = /(?:phone|windows\s+phone|ipod|blackberry|(?:android|bb\d+|meego|silk|googlebot) .+? mobile|palm|windows\s+ce|opera mini|avantgo|mobilesafari|docomo)/i;
        return regex.test(userAgent);
    }

    private static tabletDetection(userAgent: string): boolean {
        const regex = /(?:ipad|playbook|(?:android|bb\d+|meego|silk)(?! .+? mobile))/i;
        return regex.test(userAgent);
    }

    public static setDetectedDevice(device: Device) {
        this.detectedDevice = device;
    }

    public static detectDevice(userAgent: string, forceDetection: boolean = false): Device {
        if (this.isDetected && !forceDetection) {
            return this.detectedDevice;
        }
        this.isDetected = true;
        this.currentUserAgent = userAgent;
        if (this.mobileDetection(userAgent)) {
            this.detectedDevice = 'mobile';
            return this.detectedDevice;
        }
        if (this.tabletDetection(userAgent)) {
            this.detectedDevice = 'tablet';
            return this.detectedDevice;
        }
        return (this.detectedDevice = 'desktop');
    }
}

export const getDetectedDevice = (): Device => DeviceDetection.detectedDevice;
